import React from 'react'
import {Icon} from '@chakra-ui/react'

const SavedIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.413 23.0013C11.6323 23.7819 10.3729 23.7871 9.58973 23.0039L0.996086 14.4103C0.217529 13.6317 0.223002 12.3628 0.99876 11.587L12.5858 0H24V11.4142L12.413 23.0013ZM22 10.5858V2H13.4142L2.41456 12.9997L11 21.5858L22 10.5858ZM6.70712 11.2929L5.29291 12.7071L11.2929 18.7071L12.7071 17.2929L6.70712 11.2929ZM8.29291 9.70711L9.70712 8.29289L15.7071 14.2929L14.2929 15.7071L8.29291 9.70711ZM18 4C16.8952 4 16 4.89522 16 6C16 7.10478 16.8952 8 18 8C19.1048 8 20 7.10478 20 6C20 4.89522 19.1048 4 18 4Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default SavedIcon
